import React from 'react';
import { resolveMesCommandesRdvDateSources } from '../../utils/mesCommandesRdvDates';

/**
 * Colonne DATES — RDV prioritaire, réservation en secondaire.
 */
export default function MesCommandesRdvDatesCell({ commande }) {
  const { rdvAt, reservedAt } = resolveMesCommandesRdvDateSources(commande);

  if (!rdvAt && !reservedAt) {
    return <span className="text-sm text-gray-400">—</span>;
  }

  return (
    <div className="min-w-0 text-sm leading-snug">
      {rdvAt ? (
        <div className="font-semibold text-gray-900 tabular-nums">
          <span className="text-[11px] font-bold uppercase tracking-wide text-purple-700 mr-1">RDV</span>
          {rdvAt}
        </div>
      ) : null}
      {reservedAt ? (
        <div className={`text-xs text-gray-500 tabular-nums ${rdvAt ? 'mt-1' : 'font-medium text-gray-700'}`}>
          Réservé : {reservedAt}
        </div>
      ) : null}
    </div>
  );
}
